import BreadCrumbs from '@components/Breadcrumbs';
import Button from '@components/Button';
import Icon from '@material-ui/core/Icon';
import { apiClient } from '@services/api';
import { format, parseJSON } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';
import NumberFormat from 'react-number-format';
import { useHistory, useParams } from 'react-router-dom';
import ReactToPrint from 'react-to-print';

class Content extends React.Component {
  render() {
    const exit = this.props.exit
    const tourType = {
      tour: 'Passeio',
      combo: 'Combo',
      transfer: 'Traslado'
    }
    const getPaymmentsTotal = id => {
      return exit?.payments?.reduce((accumulator, currentValue) => accumulator + (currentValue.id = id ? Number(currentValue.total) : 0), 0)
    }
    if (Object.keys(exit).length !== 0) {
      return <div>
        <>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '4px 4px 16px' }}>
            <img src={`${process.env.PUBLIC_URL}/logo/large/green.png`} alt="Full Tour" style={{ height: '58px' }} />
            <span style={{ fontSize: '12px', color: '#5b6b7f' }}>Lista de passageiros{exit.tour_date ? ' · ' + format(new Date(exit.tour_date + ' 00:00:00'), 'dd/MM/yyyy') : ''}</span>
          </div>
          <div className="bg-white text-blue font-poppins" style={{ borderRadius: '0 0 10px 10px', borderTop: '3px solid #62DEC2' }}>
            <div className="px-6 py-4 text-xl text-blue font-poppins">
              <span>Informações</span>
            </div>
            <div className="flex px-6 py-4 border-t border-opacity-75">
              <div className="flex-1 font-bold">
                Produto
              </div>
              <div className="flex-1 text-center font-bold">
                Local
              </div>
              <div className="flex-1 text-right font-bold">
                Guia
              </div>
            </div>
            <div className="flex px-6 py-4 border-t border-opacity-75">
              <div className="flex-1">
                {exit.travel_name} {exit.type === 'transfer' && exit.transfer_type !== null ? `(${exit.transfer_type})` : ''}
              </div>
              <div className="flex-1 text-center">
                {tourType[exit.type]}
              </div>
              <div className="flex-1 text-right">
                {exit.guide_name}
              </div>
            </div>
          </div>
          {exit.customers !== undefined && exit.customers.map((customer) => {
            return <div className="ft-pax-card mt-4 bg-white text-blue font-poppins" style={{ borderRadius: '0 0 10px 10px', borderTop: '3px solid #62DEC2' }}>
              <div className="flex px-6 py-4 text-xl text-blue font-poppins justify-between">
                <span>{customer.name}</span>
                <div className="items-right">
                  <div className="flex items-center">
                    <div className="font-bold text-lg py-1">{exit.type === 'transfer' ? 'Horário do Voo: ' : ''}</div> {(exit.time ? exit.time : exit.time_final) &&
                      <>
                        <Icon className="mr-2">
                          access_time
                        </Icon>
                        {(customer.time_final ? `Entre ${customer.time?.slice(0, 5)} e ${customer.time_final?.slice(0, 5)}` : customer.time?.slice(0, 5))}
                      </>
                    }
                  </div>
                  {exit.type === 'transfer' ?
                    <div className="flex items-center">
                      <div className="font-bold text-lg py-1">Número do Vôo: </div> {exit?.flight_code}
                    </div>
                    : ''}
                </div>
              </div>

              <div className="flex px-6 py-4 border-t border-opacity-75">
                <div className="flex-1">
                  Hotel
                </div>
                <div className="flex-1 text-gray">
                  {customer.reservation_hotel_name || customer.addresses?.find(({ region_id }) => region_id == exit.region)?.hotel}
                </div>
              </div>
              <div className="flex px-6 py-4 border-t border-opacity-75">
                <div className="flex-1">
                  Endereço - {exit.type === 'tour' ? 'Passeio' : 'Traslado'}
                </div>
                <div className="flex-1 text-gray">
                  {customer.reservation_address_hotel || customer.addresses?.find(({ region_id }) => region_id == exit.region)?.hotel_address}
                </div>
              </div>
              <div className="flex px-6 py-4 border-t border-opacity-75">
                <div className="flex-1">
                  Número do quarto
                </div>
                <div className="flex-1 text-gray">
                  {customer.reservation_room_number || customer.addresses?.find(({ region_id }) => region_id == exit.region)?.room_number}
                </div>
              </div>
              <div className="flex px-6 py-4 border-t border-opacity-75">
                <div className="flex-1">
                  Telefone
                </div>
                <div className="flex-1 text-gray">
                  {customer.phone}
                </div>
              </div>
              <div className="flex px-6 py-4 border-t border-opacity-75">
                <div className="flex-1">
                  Passageiros
                </div>
                <div className="flex-1 text-gray">
                  {customer.passagers}
                </div>
              </div>
              <div className="flex px-6 py-4 border-t border-opacity-75">
                <div className="flex-1">
                  Valor Pendente
                </div>
                <div className="flex-1 text-gray">
                  <NumberFormat
                    value={Number(customer.total) - Number(customer.payments?.reduce((accumulator, currentValue) => accumulator + Number(currentValue.total), 0)) || 0}
                    displayType={'text'}
                    decimalSeparator={","}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    decimalPrecision={2}
                    thousandSeparator={"."}
                    isNumericString
                    prefix={`${process.env.REACT_APP_CURRENCY} `}
                    renderText={(value) => <span className="flex items-center">{value}</span>}
                  />
                </div>
              </div>
              <div className="flex px-6 py-4 border-t border-opacity-75">
                <div className="flex-1">
                  Vendedor
                </div>
                <div className="flex-1 text-gray">
                  {customer.seller_name}
                </div>
              </div>
            </div>
          })}
          <div style={{ borderTop: '2px solid #62DEC2', marginTop: '16px', paddingTop: '16px', textAlign: 'center' }}>
            <div style={{ fontSize: '13px', fontWeight: 500, color: '#0a2744' }}>Full Tour Technology</div>
            <div style={{ fontSize: '12px', color: '#5b6b7f', marginTop: '2px' }}>Sistema de gestão de reservas · v2.0</div>
            <div style={{ fontSize: '12px', color: '#5b6b7f', marginTop: '2px' }}>Marcelo Ferreira · +56 9 6736 7782</div>
          </div>
        </>
      </div>
    } else {
      return <div>
        <>
          <div className="bg-white text-blue font-poppins" style={{ borderRadius: '0 0 10px 10px', borderTop: '3px solid #62DEC2' }}>
            <div className="px-6 py-4 text-xl text-blue font-poppins">
              <span>Informações</span>
            </div>
            <div className="flex px-6 py-4 border-t border-opacity-75">
              <div className="flex-1 font-bold">
                Produto
              </div>
              <div className="flex-1 text-center font-bold">
                Local
              </div>
              <div className="flex-1 text-right font-bold">
                Guia
              </div>
            </div>
          </div>
          <div className="flex px-6 py-4 border-t border-opacity-75">
            Nenhuma veículo cadastrado para a saída
          </div>
        </>
      </div>
    }
  }
}

const Show = (props) => {
  const { type_user } = useParams();
  const { driver_id } = useParams();
  const { exit_id } = useParams();
  const { access_token } = useParams();
  const componentRef = useRef()
  const history = useHistory();
  const [exit, setExit] = useState({})
  const [showEmailModal, setShowEmailModal] = useState(false)
  const [emailTo, setEmailTo] = useState('')
  const [sendingEmail, setSendingEmail] = useState(false)
  const [downloadingPdf, setDownloadingPdf] = useState(false)
  const url = `driver/exit/${exit_id}`

  const bradecrumbsConfig = [
    {
      title: `Início`,
      active: true,
      route: `/admin/motoristas/saidas/${driver_id}/${access_token}`
    },
    {
      title: `Detalhes ${exit.travel_name !== undefined ? exit.travel_name : ''}`,
    },
    {
      title: `Saida do dia ${exit.tour_date !== undefined ? format(new Date(`${exit.tour_date} 00:00:00`), "dd/MM/yyyy") : ''}`,
    }
  ]

  const getExitDetails = url => {
    apiClient.httpInstance.get(url, {
      params: {
        access_token: access_token
      }
    }).then(response => {
      if (response.status === 200) {
        setExit(response.data);
      }
    });
  }

  useEffect(() => {
    getExitDetails(url);
  }, [url]);

  // Pré-preenche o e-mail com o do cadastro do motorista (editável antes de enviar)
  useEffect(() => {
    if (exit && (exit.driver_email || exit.email)) {
      setEmailTo(exit.driver_email || exit.email || '')
    }
  }, [exit.driver_email, exit.email]);

  const sendByEmail = () => {
    if (!emailTo) return
    setSendingEmail(true)
    apiClient.httpInstance.post(`exits/${exit_id}/resend-link`, {
      to_email: emailTo,
      type_user: 'motorista',
      access_token: access_token,
    }).then(() => {
      setSendingEmail(false)
      setShowEmailModal(false)
      alert('E-mail enviado para ' + emailTo)
    }).catch(() => {
      setSendingEmail(false)
      alert('Falha ao enviar o e-mail. Verifique o endereço e tente novamente.')
    })
  }

  // PDF gerado no servidor (DomPDF, A4 padrão) — o "Visualizar PDF" (print do navegador)
  // gerava um PDF de página não-padrão que abria bem em quem gerou mas falhava/cortava
  // dados em alguns leitores de PDF no celular do motorista. Este botão baixa o arquivo
  // pronto pra reencaminhar por WhatsApp com muito mais compatibilidade. (2026-08)
  const downloadPdf = () => {
    setDownloadingPdf(true)
    apiClient.httpInstance.get(`driver/exit/${exit_id}/pdf`, {
      params: { access_token: access_token },
      responseType: 'blob',
    }).then(response => {
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = `lista-passageiros-${exit.tour_date || exit_id}.pdf`
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(blobUrl)
      setDownloadingPdf(false)
    }).catch(() => {
      setDownloadingPdf(false)
      alert('Falha ao gerar o PDF. Tente novamente em instantes.')
    })
  }

  return <>
    <div className="px-24 pb-4">
      <div className="flex items-center justify-between mt-2 text-2xl text-blue">
        <span>Detalhes {exit.travel_name}</span>
        <div className="w-100 space-x-3">
          <Button
            textcolor="#e8f0fb"
            padding="6px 15px"
            margintop="0px"
            width="200px"
            variant="outlined"
            onClick={() => setShowEmailModal(true)}
            bgColor="transparent"
          >
            Enviar por e-mail
          </Button>
          <Button
            textcolor="#FFF"
            padding="6px 15px"
            margintop="0px"
            width="200"
            customcolor={props.theme.color}
            onClick={downloadPdf}
            disabled={downloadingPdf}
          >
            {downloadingPdf ? 'Gerando PDF...' : 'Baixar PDF'}
          </Button>
          <ReactToPrint
            trigger={() => <Button
              textcolor="#e8f0fb"
              padding="6px 15px"
              margintop="0px"
              width="200"
              variant="outlined"
              bgColor="transparent"
            >
              Visualizar (navegador)
            </Button>
            }
            content={() => componentRef.current}
            pageStyle={`
              @page { size: auto; margin: 10mm; }
              @media print {
                body { background-color: #ffffff !important; }
                * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
                /* Card do passageiro nao pode ser cortado no fim da pagina: sem isto o que
                   estoura a 1a pagina sai EM BRANCO (some ate o label). (2026-08) */
                .ft-pax-card { break-inside: avoid; page-break-inside: avoid; }
                html, body { height: auto !important; overflow: visible !important; }
              }
            `}
          />
        </div>
      </div>
      <div className="my-4">
        <BreadCrumbs items={bradecrumbsConfig} />
      </div>
      <div className="mb-4">
        <Button
          textcolor="#e8f0fb"
          padding="6px 15px"
          margintop="0px"
          width="100px"
          variant="outlined"
          bgColor="transparent"
          onClick={() => history.push(`/admin/motoristas/saidas/${driver_id}/${access_token}`)}
        >
          Voltar
        </Button>
      </div>
      <Content
        {...props}
        exit={exit}
        ref={componentRef}
      />
    </div>
    {showEmailModal &&
      <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
        <div style={{ background: '#fff', borderRadius: 10, padding: 24, width: 380, maxWidth: '90%' }}>
          <style>{`.ft-email-input{color:#172B4D !important;-webkit-text-fill-color:#172B4D !important;background:#fff !important}.ft-email-input::placeholder{color:#94a3b8 !important;-webkit-text-fill-color:#94a3b8 !important}`}</style>
          <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 4, color: '#172B4D' }}>Enviar saída por e-mail</div>
          <div style={{ fontSize: 13, color: '#718096', marginBottom: 14 }}>O link da saída será enviado para o e-mail abaixo (editável).</div>
          <input
            type="email"
            className="ft-email-input"
            value={emailTo}
            onChange={(e) => setEmailTo(e.target.value)}
            placeholder="email@exemplo.com"
            style={{ width: '100%', padding: '10px 12px', border: '1px solid #cbd5e0', borderRadius: 6, marginBottom: 18, fontSize: 14, color: '#172B4D', background: '#fff' }}
          />
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <button onClick={() => setShowEmailModal(false)} style={{ padding: '8px 16px', borderRadius: 6, border: '1px solid #cbd5e0', background: '#fff', cursor: 'pointer' }}>Cancelar</button>
            <button onClick={sendByEmail} disabled={sendingEmail || !emailTo} style={{ padding: '8px 16px', borderRadius: 6, border: 'none', background: props.theme.color, color: '#fff', cursor: (sendingEmail || !emailTo) ? 'not-allowed' : 'pointer', opacity: (sendingEmail || !emailTo) ? 0.6 : 1 }}>{sendingEmail ? 'Enviando...' : 'Enviar'}</button>
          </div>
        </div>
      </div>
    }
  </>
}

export default Show;